export default "__VITE_ASSET__CKtHRmdi__"